import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-[#C5A059] mb-8">
            <ArrowLeft size={16} />
            Back to Home
          </Link>

          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-[#C5A059]/20 rounded-lg flex items-center justify-center">
              <Scale className="text-[#C5A059]" size={24} />
            </div>
            <h1 className="font-manrope font-bold text-3xl text-white">Terms of Service</h1>
          </div>

          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 text-lg mb-8">
              Last updated: February 2026
            </p>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Acceptance of Terms</h2>
              <p className="text-gray-300">
                By accessing and using Digital Gold Gang, you accept and agree to be bound by these Terms of 
                Service. If you do not agree to these terms, please do not use our website.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Use of Service</h2>
              <p className="text-gray-300 mb-4">You agree to use our service only for lawful purposes and in accordance with these Terms. You agree not to:</p>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Violate any applicable laws or regulations</li>
                <li>Post false, misleading, or fraudulent content</li>
                <li>Harass, abuse, or harm other users</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Use automated systems to access the service without permission</li>
                <li>Impersonate others or misrepresent your affiliation</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">User Accounts</h2>
              <p className="text-gray-300">
                When you create an account, you are responsible for maintaining the security of your account 
                and all activities that occur under it. You must immediately notify us of any unauthorized 
                use of your account.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">User Content</h2>
              <p className="text-gray-300 mb-4">
                By posting content on Digital Gold Gang, you grant us a non-exclusive, worldwide, royalty-free 
                license to use, display, and distribute your content on our platform. You retain ownership of 
                your content and are responsible for ensuring it does not violate any third-party rights.
              </p>
              <p className="text-gray-300">
                We reserve the right to remove any content that violates these Terms or that we deem inappropriate.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Intellectual Property</h2>
              <p className="text-gray-300">
                All content, features, and functionality of our website (excluding user-generated content) are 
                owned by Digital Gold Gang and are protected by international copyright, trademark, and other 
                intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Disclaimer of Warranties</h2>
              <p className="text-gray-300">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER 
                EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, OR 
                ERROR-FREE.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Limitation of Liability</h2>
              <p className="text-gray-300">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, DIGITAL GOLD GANG SHALL NOT BE LIABLE FOR ANY 
                INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF YOUR 
                USE OF THE SERVICE.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Financial Disclaimer</h2>
              <div className="bg-[#C5A059]/10 border border-[#C5A059]/30 rounded-lg p-6">
                <p className="text-gray-200">
                  All content is for educational purposes only and does not constitute financial advice. 
                  Trading involves substantial risk. See our <Link to="/disclaimer" className="text-[#C5A059] hover:underline">Disclaimer</Link> for 
                  full details.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Modifications</h2>
              <p className="text-gray-300">
                We reserve the right to modify these Terms at any time. We will notify users of significant 
                changes by posting a notice on our website. Continued use of the service after changes 
                constitutes acceptance of the modified Terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-manrope font-bold text-xl text-white mb-4">Contact</h2>
              <p className="text-gray-300">
                For questions about these Terms, please contact us through our community forum.
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;
